import {AnalisisPage} from './AnalisisPage';
export default AnalisisPage;